<template>
  <v-list class="pb-3">
    <TermsOfUseListItem
      v-for="(section, index) in sections"
      :key="index"
      :route="section.route"
      :href="section.href"
      :title="section.title"
      @click="$emit('navigate')"
    />
  </v-list>
</template>

<script setup lang="ts">
defineEmits(['navigate'])
const locale = useAppLocale()

const sections = [
  {
    route: 'terms-of-use',
    title: 'Пользовательское соглашение',
  },
  {
    route: 'privacy-policy',
    title: 'Обработка персональных данных',
  },
  {
    route: 'license-agreement',
    title: 'Лицензионное соглашение',
  },
  ...(locale.isRu
    ? [
      { route: 'public-offer', title: 'Публичная оферта' },
      { route: 'documents', title: 'Документы юрлица' },
      { href: '/documents/users-guide.pdf', title: 'Руководство пользователя' },
      { href: '/documents/confidential-policy.pdf', title: 'Политика конфиденциальности' },
    ]
    : []),
]
</script>
